<template>
	<div class="container">
		<!-- {{dataPortfolios}} -->
		<img src="@/assets/images/ornament-circle-bottom.svg" alt="bottom-image-ornament" class="home-ornament-bottom">
		<div class="product-content content-default">
			<h1 class="title-default primary">
				<div class="text">Portfolios</div>
				<img src="@/assets/images/title-ornament.svg" alt="home-ornament-bottom" class="w-ornament">
			</h1>

			<div class="text-center" v-if="portfoliosAvailable">
				<img src="@/assets/images/empty-state.svg" alt="empty-state" style="width: 250px;">
			</div>

            <div class="row justify-content-start" v-if="!loadPortfolios">
                <div class="col-12 col-md-6 col-lg-4 box-product-wrapper" v-for="(item, index) in dataPortfolios" :key="item.key + index">
                    <div class="box-product">
                        <router-link :to="'portfolios/'+ item.key">
                            <img v-lazy="item.imageThumbnail" style="width: 100%; border: 1px solid #f2f2f2; border-radius: 5px;" alt="image-portfolio">
                        </router-link>
                        <router-link 
                        class="link-default"
                        :to="'/portfolios/slug'"><h2 class="title">{{item.title}}</h2></router-link>
                        <p class="price">{{item.category}}</p>
                    </div>
                </div>
            </div>

			<div class="row" v-else>
				<div class="col-12 col-md-6 col-lg-4" v-for="index in 12" :key="index">
					<skeleton-loading>
						<square-skeleton :boxProperties="{
							bottom: '15px',
							width: '100%',
							height: '210px'
							}">
						</square-skeleton>
						<square-skeleton :boxProperties="{
						bottom: '15px',
						width: '100%',
						height: '15px'
						}">
						</square-skeleton>
						
						<square-skeleton :boxProperties="{
						bottom: '15px',
						width: '50%',
						height: '15px'
						}">
						</square-skeleton>
					</skeleton-loading>
				</div>
			</div>

			<div class="text-center pb-30" v-if="loadNextPortfolios">
				<Loader/>
			</div>
		</div>
	</div>
</template>

<script>
	import Loader from '@/components/Loader'

	import firebase from 'firebase/app'
	
	let LAST_VISIBLE
	let PORTFOLIO_COUNT
	const LIMIT = 12
	
	export default {
		metaInfo: {
			title: 'Portfolios - Jung Rama'
		},
		data(){
			return{
				loadPortfolios: true,
				loadNextPortfolios: false,
				portfoliosAvailable: false,
				
				dataPortfolios: []
			}
		},
		components: {
			Loader
		},
		methods:{
			countPortfolioData(){
				firebase.firestore()
				.collection('portfolios')
				.get().then(querySnapshoot => {
					PORTFOLIO_COUNT = querySnapshoot.size
				})
			},
			getPortfolioData(){

				this.loadPortfolios = true
				
				firebase.firestore()
				.collection('portfolios')
				.orderBy('lastUpdated', 'desc')
				.limit(LIMIT)
				.get()
				.then(async querySnapshoot => {

					if(querySnapshoot.size <= 0){
						this.portfoliosAvailable = true
					}
					
					LAST_VISIBLE = querySnapshoot.docs[querySnapshoot.docs.length-1];
					
					const portfolio = await querySnapshoot.docs.map(doc =>{
						return {
							key: doc.id,
							...doc.data()
						}
					})
					
					this.loadPortfolios = false
					this.dataPortfolios = portfolio

					if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
						if(this.dataPortfolios.length < PORTFOLIO_COUNT){
							this.getNextPortfolioData()
						}
					}
				})

			},
			getNextPortfolioData(){
				this.loadNextPortfolios = true

				firebase.firestore()
				.collection('portfolios')
				.orderBy('lastUpdated', 'desc')
				.startAfter(LAST_VISIBLE)
				.limit(LIMIT)
				.get()
				.then(async querySnapshoot => {
					LAST_VISIBLE = querySnapshoot.docs[querySnapshoot.docs.length-1];
					
					const portfolio = await querySnapshoot.docs.map(doc =>{
						return {
							key: doc.id,
							...doc.data()
						}
					})

					this.loadNextPortfolios = false
					this.dataPortfolios.push(...portfolio)
				})
			},
			scroll () {
				window.onscroll = () => {
					if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
						if(this.dataPortfolios.length < PORTFOLIO_COUNT){
							this.getNextPortfolioData()
						}
					}
				};
			},
		},
		async mounted(){
			await this.countPortfolioData()
			await this.getPortfolioData()
			await this.scroll();

			// firebase.firestore()
			// .collection('portfolios')
			// .add(
			// 	{
			// 		"title":"Product 15",
			// 		"imageThumbnail":"https://firebasestorage.googleapis.com/v0/b/vue-project-jr.appspot.com/o/1557408277039thumb-01.jpg?alt=media&token=14686a62-600b-4837-9a59-8e62fc665bef",
			// 		"imageDetail":"https://firebasestorage.googleapis.com/v0/b/vue-project-jr.appspot.com/o/1557408069825960bd572979565.5bfa9b5022a29.jpg?alt=media&token=c5b751e9-048b-4a5f-9c6e-eb9b75573801",
			// 		"category": 'UI/UX',
			// 		"collaboration": 'Sandevelopment',
			// 		"description":"\t\t\tLorem ipsum, dolor sit amet consectetur adipisicing elit. Doloremque, maxime ut itaque voluptatum officiis fuga praesentium provident delectus enim sed ab id consectetur quam ex? Officiis tempora illum voluptatum doloribus.",
			// 		"lastUpdated": new Date()
			// 	}
			// )
			
		}
	}
</script>